import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'i2g-toast',
  templateUrl: 'toast.component.html',
  styleUrls: ['toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit, OnDestroy {
  /**
   * Unique identifier
   */
  @Input() id: string;

  /**
   * Text message
   */
  @Input() message: string;

  /**
   * Delay in seconds before dismissing the toast
   */
  @Input() timeout;

  /**
   * Position of the toast
   */
  @Input() position: number;

  private intervalId: NodeJS.Timeout;

  constructor(private _toastService: ToastService) {}

  ngOnInit() {
    this.intervalId = global.setTimeout(
      () => this._toastService.popById(this.id),
      this.timeout * 1000
    );
  }

  ngOnDestroy() {
    global.clearTimeout(this.intervalId);
  }
}
